import { render, staticRenderFns } from "./PetsList.vue?vue&type=template&id=30ad09e6"
import script from "./PetsList.vue?vue&type=script&lang=js"
export * from "./PetsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports